import { FormType } from '../../../../form-types';

export const wlusOral_2024: FormType = {
  name: 'Weight Loss Oral Drops [Archived]',
  olderVersions: ['wlus_archived'],
  questions: [
    {
      key: 'wlus_genderIdentify',
      next: {
        condition: { 'wlus_genderIdentify.wlus_genderIdentify_male': true },
        key: 'wlus_weightAndHeight2025',
        els: 'wlus_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlus_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlus_pregnantOrBreastfeedingOrPlanningTo.wlus_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_consentPregnancy'
      }
    },
    {
      key: 'wlus_consentPregnancy',
      next: {
        condition: {
          'wlus_consentPregnancy.wlus_consentPregnancy_non_consent': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_weightAndHeight2025'
      }
    },
    'wlus_weightAndHeight2025',
    {
      key: 'wlus_consentBmi',
      next: {
        condition: {
          'wlus_consentBmi.wlus_consentBmi_non_consent': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_MedicalConditions'
      }
    },
    {
      key: 'wlus_MedicalConditions',
      next: {
        switch: [
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_noneOfTheAbove':
                true
            },
            key: 'wlus_hadAGastricBypassInThePast6Months'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gastroparesis':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_triglyceridesOver600AtAnyPoint':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreaticCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreatitis': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_type1Diabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_hypoglycemia': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_insulinDependentDiabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_thyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfThyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_anorexiaOrBulimia':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_currentSymptomaticGallstones':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gallbladderRemoved':
                true
            },
            key: 'wlus_consentGallbladder'
          }
        ],
        els: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
      }
    },
    'wlus_consentGallbladder',
    'wlus_tellUsMoreAboutAboutYourMedicalConditions',
    {
      key: 'wlus_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlus_hadAGastricBypassInThePast6Months.wlus_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_allergicToAnyOfTheFollowing'
      }
    },
    {
      key: 'wlus_allergicToAnyOfTheFollowing',
      next: {
        condition: {
          'wlus_allergicToAnyOfTheFollowing.wlus_allergicToAnyOfTheFollowing_noneOfTheAbove':
            true
        },
        key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
      next: {
        condition: {
          'wlus_doYouTakeAnyOfTheFollowingMedications.wlus_doYouTakeAnyOfTheFollowingMedications_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications'
      }
    },
    {
      key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications',
      next: {
        switch: [
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_semiglutide':
                true
            },
            key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication'
          },
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_tirzepatide':
                true
            },
            key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication'
          }
        ],

        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    {
      key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlus_describeTheSideEffectsThatYouHaveExperienced',
        els: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
      }
    },
    'wlus_describeTheSideEffectsThatYouHaveExperienced',
    'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    {
      key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription',
      next: {
        condition: {
          'wlus_doYouHaveAPictureOfYourCurrentPrescription.wlus_doYouHaveAPictureOfYourCurrentPrescription_yes':
            true
        },
        key: 'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',

    'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlus_consentTruthfulness',
      next: {
        condition: {
          'wlus_consentTruthfulness.wlus_consentTruthfulness_consent': true
        },
        key: 'wlus_consentGLP1GIP',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_consentGLP1GIP',
      next: {
        condition: {
          'wlus_consentGLP1GIP.wlus_consentGLP1GIP_non_consent': true
        },

        key: 'wlus_ineligible',
        els: 'wlus_complete'
      }
    },
    'wlus_ineligible',
    'wlus_complete'
  ]
};
